export default __webpack_public_path__ + "static/media/CORE_health_plan.8bd27ce2.png";